/* src/app/private/components/lead-fields-configurations/add-lead-field/add-lead-field.component.scss */
.p-inputtext {
  box-shadow: none !important;
}
.p-select {
  box-shadow: none !important;
}
label {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 12px;
}
/*# sourceMappingURL=add-lead-field.component.css.map */
